module.exports = __webpack_public_path__ + "static/assistenza-d453beceb4a13b1aead4bce2631e7247.jpg";